import * as moment from 'moment';
import { AppConsts } from '../src/shared/AppConsts';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Type, CompilerOptions, NgModuleRef, Injector } from '@angular/core';
import { environment } from './environments/environment';
import "moment-timezone";
import * as $ from "jquery";
import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
import { AlertController, Platform } from '@ionic/angular';
import { NetworkServicesService } from '@app/_services/network-services.service';
import { Router } from '@angular/router';
import { Globals } from '@app/globals';
import { AppToasterService } from '@shared/service/app-toaster.service';
import { StringUtils } from '@shared/utils/StringUtils';


export class AppPreBootstrap {
    static alert: any;
    static netwrok: any;
    static connectSubscription: any;
    static alertCtrl: AlertController;
    static networkService: NetworkServicesService;
    static isMobile: boolean = false;
    static _router: Router;
    static globals: Globals
    static _notify: AppToasterService

    static runDesktop(appRootUrl: string, callback: () => void): void {
        // Check if this is a public route and skip authentication
        const url = new URL(window.location.href);
        if (url.pathname.startsWith('/public/')) {
            console.log('Skipping desktop bootstrap for public route:', url.pathname);
            callback();
            return;
        }
        
        AppPreBootstrap.getApplicationConfigDesktop(() => {

            AppPreBootstrap.getUserConfiguration(callback);
        });
    }
    static async refresh(callback) {
        console.log("called refresh");
        if (this.alert != null) {
            console.log("called dismissed");
            this.alert.dismiss();
        }
        abp.ui.setBusy();
        AppPreBootstrap.getApplicationConfigMobile(async () => {
            //settting selected country code and base url on the basis of mobile geolocation
            //if mobile located country code matches with remote configuration country code
            //if not found country code and api url would be set to fisrt element of country array
            var cs = JSON.parse(window.localStorage.getItem('countries'))
            // console.log("cs-",cs)
            // console.log("window.localStorage.getItem('countryCode')-",window.localStorage.getItem('countryCode'))
            // console.log("window.localStorage.getItem('MobileLocation')-",window.localStorage.getItem('MobileLocation'))
            var selectedCountry = window.localStorage.getItem('countryCode');
            // console.log("selectedCountry-",selectedCountry);
            //if selected country code not found then set it to mobilelocation country code
            //if selected country code is set but not a valid code (not in remote config countries)
            //then set it to first code
            if (window.localStorage.getItem('MobileLocation') != null) {
                if (selectedCountry == null) {
                    if (cs.findIndex((c) => { return c['title'].toLowerCase() == window.localStorage.getItem('MobileLocation').toLowerCase() }) > -1) {
                        window.localStorage.setItem('countryCode', window.localStorage.getItem('MobileLocation').toLowerCase());
                    }
                    else {
                        window.localStorage.setItem('countryCode', cs[0]['title'].toLowerCase());
                    }
                }
            }
            else if (selectedCountry == null) {
                window.localStorage.setItem('countryCode', cs[0]['title'].toLowerCase());
            }
            else if (selectedCountry != null && (cs.findIndex((c) => { return c['title'].toLowerCase() == selectedCountry.toLowerCase() }) == -1) || selectedCountry == null) {
                window.localStorage.setItem('countryCode', cs[0]['title'].toLowerCase());
            }
            // console.log("selectedCountry-",selectedCountry)
            var selectedApiUrl = JSON.parse(window.localStorage.getItem('apiUrls'));
            // console.log("selectedApiUrl-",selectedApiUrl)
            AppConsts.remoteServiceBaseUrl = selectedApiUrl[window.localStorage.getItem('countryCode')];
            // console.log("AppConsts.remoteServiceBaseUrl-",AppConsts.remoteServiceBaseUrl)


            console.log('get network connection!');
            AppPreBootstrap.getUserConfiguration(callback);
        });
        //   window.location.reload();
    }

    static async runMobile(isMobile, appRootUrl: string, netwrok, injector, callback: () => void): Promise<void> {
        // Check if this is a public route and skip authentication
        const url = new URL(window.location.href);
        if (url.pathname.startsWith('/public/')) {
            console.log('Skipping mobile bootstrap for public route:', url.pathname);
            callback();
            return;
        }
        
        if (isMobile) {
            const platform: Platform = injector.get(Platform);
            this._router = injector.get(Router);
            this.globals = injector.get(Globals);
            if (window.localStorage.getItem("clearHistoryStartingPoint") != null && window.localStorage.getItem("clearHistoryStartingPoint") == '1') {
                window.localStorage.removeItem('clearHistoryStartingPoint');
            } else {

                if (StringUtils.isMobilePlatform(platform) && platform.is('android')) {
                    navigator['app'].clearHistory();
                }


            }
        }
        this.alertCtrl = injector.get(AlertController);
        this.netwrok = netwrok;
        this.isMobile = isMobile;
        this.networkService = injector.get(NetworkServicesService);
        this._notify = injector.get(AppToasterService);
        if (this.networkService.refresh$.subscribe(() => this.refresh(callback))) {
            console.log('internet connection available!');

            AppPreBootstrap.getApplicationConfigMobile(async () => {

                if (netwrok.type != 'none') {
                    //settting selected country code and base url on the basis of mobile geolocation
                    //if mobile located country code matches with remote configuration country code
                    //if not found country code and api url would be set to fisrt element of country array
                    var cs = JSON.parse(window.localStorage.getItem('countries'))
                    // console.log("cs-",cs)
                    // console.log("window.localStorage.getItem('countryCode')-",window.localStorage.getItem('countryCode'))
                    // console.log("window.localStorage.getItem('MobileLocation')-",window.localStorage.getItem('MobileLocation'))
                    var selectedCountry = window.localStorage.getItem('countryCode');
                    // console.log("selectedCountry-",selectedCountry);
                    //if selected country code not found then set it to mobilelocation country code
                    //if selected country code is set but not a valid code (not in remote config countries)
                    //then set it to first code
                    if (window.localStorage.getItem('MobileLocation') != null) {
                        if (selectedCountry == null) {
                            if (cs.findIndex((c) => { return c['title'].toLowerCase() == window.localStorage.getItem('MobileLocation').toLowerCase() }) > -1) {
                                window.localStorage.setItem('countryCode', window.localStorage.getItem('MobileLocation').toLowerCase());
                            }
                            else {
                                window.localStorage.setItem('countryCode', cs[0]['title'].toLowerCase());
                            }
                        }
                    }
                    else if (selectedCountry == null) {
                        window.localStorage.setItem('countryCode', cs[0]['title'].toLowerCase());
                    }
                    else if (selectedCountry != null && (cs.findIndex((c) => { return c['title'].toLowerCase() == selectedCountry.toLowerCase() }) == -1) || selectedCountry == null) {
                        window.localStorage.setItem('countryCode', cs[0]['title'].toLowerCase());
                    }
                    // console.log("selectedCountry-",selectedCountry)
                    var selectedApiUrl = JSON.parse(window.localStorage.getItem('apiUrls'));
                    // console.log("selectedApiUrl-",selectedApiUrl)
                    AppConsts.remoteServiceBaseUrl = selectedApiUrl[window.localStorage.getItem('countryCode')];
                    // console.log("AppConsts.remoteServiceBaseUrl-",AppConsts.remoteServiceBaseUrl)


                    console.log('get network connection!');
                    AppPreBootstrap.getUserConfiguration(callback);
                } else {
                    if (this.alert != null) {
                        this.alert.dismiss();
                    }
                    this.alert = await this.alertCtrl.create({
                        header: '',
                        backdropDismiss: false,
                        message: 'Please check your network connection',
                        cssClass: 'alertCustomCss'
                        // buttons: [
                        //     {
                        //         text: 'Close',
                        //         role: 'OK',
                        //         handler: () => {
                        //             this.alert.dismiss();
                        //             navigator['app'].exitApp();
                        //         }
                        //     }
                        // ]
                    });
                    await this.alert.present();
                    abp.ui.clearBusy();
                }
                //   AppPreBootstrap.getUserConfiguration(callback);
            });
        } else {
            console.log('no internet connection');
            if (this.alert != null) {
                this.alert.dismiss();
            }
            this.alert = await this.alertCtrl.create({
                header: '',
                backdropDismiss: false,
                message: 'Please check your network connection',
                cssClass: 'alertCustomCss'
                // buttons: [
                //     {
                //         text: 'Close',
                //         role: 'OK',
                //         handler: () => {
                //             this.alert.dismiss();
                //             navigator['app'].exitApp();
                //         }
                //     }
                // ]
            });
            await this.alert.present();
            abp.ui.clearBusy();
        }

    }

    static bootstrap<TM>(moduleType: Type<TM>, compilerOptions?: CompilerOptions | CompilerOptions[]): Promise<NgModuleRef<TM>> {
        return platformBrowserDynamic().bootstrapModule(moduleType, compilerOptions);
    }

    private static getApplicationConfigDesktop(callback: () => void) {

        // AppConsts.appBaseUrl = window.location.origin;
        AppConsts.remoteServiceBaseUrl = environment.apiUrl.defaultUrl;
        AppConsts.localeMappings = environment.localeMappings;
        AppConsts.culture = (environment as any).culture;
        AppConsts.apppath = (environment as any).apppath;
        // AppConsts.accountingBaseUrl = result.accountingBaseUrl;

        //changes language
        if (abp.utils.getCookieValue('Abp.Localization.CultureName') == null || abp.utils.getCookieValue('Abp.Localization.CultureName') == 'null' ||
            abp.utils.getCookieValue('Abp.Localization.CultureName') == '') {
            abp.utils.setCookieValue(
                'Abp.Localization.CultureName',
                AppConsts.culture,
                new Date(new Date().getTime() + 5 * 365 * 86400000), // 5 year
                AppConsts.apppath
            );

            moment.locale(AppConsts.culture);
        }

        callback();
    }

    private static async getApplicationConfigMobile(callback: () => void) {
        if (this.netwrok.type != 'none') {
            return $.ajax({
                "async": true,
                "crossDomain": true,
                "url": environment.remoteEnvUrl,
                "method": 'GET',
            }).done(result => {
                //find and set urls
                // console.log("remoteEnvUrl-result",result)
                // console.log("result",result[environment.env])
                var envrConfig = result[environment.env];
                if (envrConfig == undefined) {
                    // console.log("envrConfig-if-",envrConfig)
                    AppConsts.remoteServiceBaseUrl = environment.apiUrl.defaultUrl;
                    window.localStorage.removeItem('countryCode');
                    window.localStorage.removeItem('countries');
                    window.localStorage.removeItem('apiUrls');
                    // removing latest version of app from local Storage
                    window.localStorage.removeItem('currentVersionAndroid');
                    window.localStorage.removeItem('currentVersioniOS');
                }
                else {
                    window.localStorage.setItem("countries", (JSON.stringify(result[environment.env]["countries"])));
                    window.localStorage.setItem("apiUrls", (JSON.stringify(result[environment.env]["apiUrl"])));
                    // saving latest version of app from local Storage
                    console.log('currentVersionAndroid save in local storage', (result[environment.env]["currentVersionAndroid"]));
                    console.log('iOSLatestVersion save in local storage', (result[environment.env]["currentVersioniOS"]));
                    window.localStorage.setItem("currentVersionAndroid", (result[environment.env]["currentVersionAndroid"]));
                    window.localStorage.setItem("currentVersioniOS", (result[environment.env]["currentVersioniOS"]));
                }
                callback();
            });
        }
        else {
            if (this.alert != null) {
                this.alert.dismiss();
            }
            this.alert = await this.alertCtrl.create({
                header: '',
                backdropDismiss: false,
                message: 'Please check your network connection',
                cssClass: 'alertCustomCss'
                // buttons: [
                //     {
                //         text: 'Close',
                //         role: 'OK',
                //         handler: () => {
                //             this.alert.dismiss();
                //             navigator['app'].exitApp();
                //         }
                //     }
                // ]
            });
            await this.alert.present();
            abp.ui.clearBusy();
            return null;
        }
    }

    private static getCurrentClockProvider(currentProviderName: string): abp.timing.IClockProvider {
        if (currentProviderName === 'unspecifiedClockProvider') {
            return abp.timing.unspecifiedClockProvider;
        }

        if (currentProviderName === 'utcClockProvider') {
            return abp.timing.utcClockProvider;
        }

        return abp.timing.localClockProvider;
    }

    private static async getUserConfiguration(callback: () => void): Promise<JQueryPromise<any>> {
        const onSuccess = (async result => {
            if (this.isMobile) {
                if (this.alert != null) {
                    this.alert.dismiss();
                }
            }
            var res = result.result;
            // for resolve full app refresh on cu click

            //     if (this.isMobile) {
            //     if(res != null) {
            //         console.log('contribution view' + res.auth.allPermissions['Tenant.Contribution.View']);
            //         var contributionView = res.auth.allPermissions['Tenant.Contribution.View'];
            //         var contributionCreate = res.auth.allPermissions['Tenant.Contribution.Create'];

            //         window.localStorage.setItem('contributionView', contributionView);
            //         window.localStorage.setItem('contributionCreate', contributionCreate);
            //     }
            //   }


            $.extend(true, abp, res);
            abp.auth.grantedPermissions = res.auth.grantedPermissions;

            abp.clock.provider = this.getCurrentClockProvider(res.clock.provider);

            moment.locale(abp.localization.currentLanguage.name);

            if (abp.clock.provider.supportsMultipleTimezone) {
                moment.tz.setDefault(abp.timing.timeZoneInfo.iana.timeZoneId);
            }

            callback();
        })

        const onFailure = (async result => {
             // Error handling in case of SSL (Man-in-the-Middle) failure
             const SSL_ERROR_CODES = [-1022, -1200, -1201, -1202, -1203, -1204, -1205, -1206];
             if (this.isMobile && SSL_ERROR_CODES.includes(result.errorcode)) {
                 this._notify.error("Can not establish secure connection with the server!", null, { preventDuplicates: true, positionClass: 'toast-top-right' });
                 return;
             }
            abp.utils.deleteCookie(AppConsts.authorization.encryptedAuthTokenName, '/');
            abp.utils.deleteCookie(AppConsts.authorization.AuthToken, '/');

            if (this.isMobile) {
                //    if (this.netwrok.type == 'none') {
                if (this.alert != null) {
                    this.alert.dismiss();
                    this.alert = null;
                }
                this.alert = await this.alertCtrl.create({
                    header: '',
                    backdropDismiss: false,
                    message: 'Something went wrong please check your network connection',
                    buttons: [
                        {
                            text: 'Retry',
                            role: 'OK',
                            handler: () => {
                                this.alert.dismiss();
                                this.refresh(callback);
                            }
                        }
                    ],
                    cssClass: 'alertCustomCss'
                });
                if (this.globals.alertsArr.length > 0) {
                    this.globals.alertsArr.forEach(e => {
                        e.dismiss();
                    });
                }
                this.globals.alertsArr = [];
                this.globals.alertsArr.push(this.alert);
                await this.alert.present();
                abp.ui.clearBusy();
                //    } else {
                //     abp.ui.clearBusy();
                //     this._router.navigate(['./account/login'], { replaceUrl: true });
                //    }
            } else {
                window.location.href = './account/login';

            }
            // callback();
        })

        if (this.isMobile) {
            if (this.alert != null) {
                this.alert.dismiss();
            }
        }

        // For mobile we're using SSL plugin for API calls to handle SSL Pinning, which handles cookies native side
        // not accessible to javascript, which gives us incorrect data here, so to avoid that, we're also using same plugin here
        if (this.isMobile) {
            this.getUserConfigurationUsingSsl()
                .then((pluginRes: any) => {
                    const res = JSON.parse(pluginRes.data);
                    onSuccess(res);
                })
                .catch(onFailure);
            return;
        }

        return $.ajax({
            url: AppConsts.remoteServiceBaseUrl + '/AbpUserConfiguration/GetAll',
            type: 'GET',
            xhrFields: { withCredentials: true },
            beforeSend: function (xhr) {
                xhr.setRequestHeader("Authorization", 'Bearer ' + abp.auth.getToken())
                xhr.setRequestHeader('.AspNetCore.Culture', abp.utils.getCookieValue('Abp.Localization.CultureName'))
                xhr.setRequestHeader('Abp.TenantId', abp.multiTenancy.getTenantIdCookie()?.toString())

            },
        })
        .done(onSuccess)
        .fail(onFailure)
    }

    /**
     * This logic is put into a separate promise function because having it directly in observable was causing
     * UI freeze (data not reflecting till we touch the screen), having it here fix the issue for some reason
     * @returns a Promise of type HttpResponse
     */
    private static getUserConfigurationUsingSsl() {
        return new Promise((resolve, reject) => {
            const params = {
                    url : AppConsts.remoteServiceBaseUrl + '/AbpUserConfiguration/GetAll',
                    headers: {
                        Authorization: 'Bearer ' + abp.auth.getToken(),
                        '.AspNetCore.Culture': abp.utils.getCookieValue('Abp.Localization.CultureName'),
                        'Abp.TenantId': abp.multiTenancy.getTenantIdCookie() + "",
                        "Content-Type": 'application/json'
                    }
            };
            console.warn('verifySslValidity params: ', params);
            window['sslHTTP'].get(params, onSslHttpSuccess, onSslHttpFailure)

            function onSslHttpSuccess(response) {
                console.warn('verifySslValidity success: ', params.url, response);
                resolve(response);
            }

            function onSslHttpFailure(error) {
                console.warn('verifySslValidity failure: ', params.url, JSON.stringify(error));
                reject(error);
            }
        })
    }

    static initSignalR(callback?: () => void): void {

        // console.log("initSignalR called")
        const encryptedAuthToken = new UtilsService().getCookieValue(AppConsts.authorization.encryptedAuthTokenName);

        // console.log("encryptedAuthToken-",encryptedAuthToken)
        // console.log("AppConsts.remoteServiceBaseUrl-",AppConsts.remoteServiceBaseUrl)
        abp.signalr = {
            autoConnect: true,
            connect: undefined,
            hubs: undefined,
            qs: AppConsts.authorization.encryptedAuthTokenName + '=' + encodeURIComponent(encryptedAuthToken),
            remoteServiceBaseUrl: AppConsts.remoteServiceBaseUrl,
            startConnection: undefined,
            url: '/signalr'
        };

        const script = document.createElement('script');
        if (callback) {
            script.onload = () => {
                callback();
            };
        }
        // console.log("AppConsts.appBaseUrl-",AppConsts.appBaseUrl)
        script.src = './assets/abp/abp.signalr-client.js';
        // console.log("script.src-",script.src)
        document.head.appendChild(script);
    }
    static async showAlert() {

    }
}
